<template>
  <drag-modal :visible="$store.state.dislog.stepbox" @cancel="close" title='选择进度' width='840px' class="modal">
      <div class="setnewstepbtn">
        <a-button icon="edit"
          style="margin-left:10px;" @click="setnewStep">修改最新进度</a-button>
      </div>
    <div class="dl" v-for='(i, index) in Step' :key='index'>
      <!-- <div class="li" v-for='(i,index) in Step' :key='index' @click='lick(i)'>{{i.name}}</div> -->
      <div class="levelone">{{ index == 0 ? '标准进度': index == 7 ? '特殊进度':''}}</div>
      <div class="dt">{{ stepTit[index] }}</div>
      <div class="dd">
        <!-- ||j.lite == 180 || ( (j.name === '恢复执行' ||j.name === '执恢终本') && (Step[6].some(item => item.name === '终本' && !item.isover) || Step[6].some(item => item.name === '结案' && item.isover))) -->
        <div class="a" v-for='(j, ind) in i' :key='`${index}_${ind}`' @click='lick(j,index)' 
        :class="{ 'over': (j.time && j.lite < 161 && j.name != '诉前保全' ) || (j.time && j.name == '结案')  }"
          v-if="j.lite != 181">
          {{ j.name }}</div>
      </div>
    </div>
    <drag-modal :visible="stepVisible" @cancel="closenewstep" title='修改最新进度' width='400px'>
      <a-spin :spinning="loading" class="stepmodel">
          <div>
              <label>当前进度：</label>
              <a-select style="margin-left: 10px;width: 220px;"
                  :value="newStepid === 0 ? null : newStepid" placeholder="当前进度" class="nselect"
                  show-search @change="setSteps($event)" :filter-option="filterOption">
                  <a-select-option v-for="item in newhasjdList" :key="item.step">{{ item.title }}（{{ item.create_time.slice(0,10) }}）</a-select-option>
              </a-select>
          </div>
          <div style="margin-top: 40px;">
              <a-popconfirm :title="'确认修改当前进度为' + newStep +'吗?'" ok-text="确定" cancel-text="取消"
                  @confirm="setconfirm">
                  <a-button type="primary" style="width:130px;">
                      提交
                  </a-button>
              </a-popconfirm>
              <a-button style="margin-left: 20px;width:130px;background:#B2C9E1;color:#fff;"
                  @click='closenewstep'>取消</a-button>
          </div>
      </a-spin>
    </drag-modal>
  </drag-modal>
  
</template>
<script>
import {setnewStep} from '@/server/speed'
export default {
  name: 'StepSel',
  props: {
    Step: {
      type: Object,
      default() {
        return {}
      }
    },
    Arr: {
      type: Array,
      default() {
        return []
      }
    },
    hasjdList: {
      type: Array,
      default() {
        return []
      }
    },
    causeType: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      newStepItem:{},
      stepVisible:false,
      newStep:'',
      newStepid:'',
      loading:false,
      newhasjdList:[]
    }
  },
  computed: {
    StepArr() {
      let Arr = []
      for (let val in this.Step) {
        Arr = Arr.concat(this.Step[val])
      }
      return Arr
    },
    stepTit(){
      if(this.causeType === 1){
        // 诉讼主线
        return ["准备", "一审", "二审", "重审", "再审", "审判监督", "执行"]
      }else{
        // 仲裁主线
        return ["准备", "仲裁审理", "", "", "", "", "执行"]
      }
    }
  },
  methods: {
    setnewStep() {
      this.stepVisible = true
      this.newStep = this.hasjdList[this.hasjdList.length - 1].title
      this.newStepid = this.hasjdList[this.hasjdList.length - 1].step
      let lists = [...this.hasjdList].sort((a, b) => a.step - b.step);
      this.newhasjdList = lists
    },
    setSteps(value) {
        this.newStepid = value || 0
    },
    filterOption(input, option) {
        return (
            option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
    },
    setconfirm() {
      let id = this.$store.state.cause.id
      setnewStep({ id: id, step: this.newStepid }).then(res=>{
        this.$message.success({ content: '修改成功', key: 'updatable' });
        this.closenewstep()
        this.close()
        this.$parent.$parent.init(this.$store.state.cause.id)
      })
    },
    close() {
      this.$store.dispatch('openkey', { key: 'stepbox', by: false })
    },
    closenewstep() {
      this.stepVisible = false
    },
    lick(i,index) {
      if(index == 7 && this.Arr.length == 10) {
        this.$message.error({ content: '特殊进度数量不超过 10' });
        return false
      }
      if ((i.time && i.lite < 161 && i.name != '诉前保全' ) || (i.time && i.name == '结案')) return false;
      if(index == '7'){
        const hasThisItem = this.Arr.some(item => item.name === i.name)
        if (hasThisItem) {
          this.newStepItem = Object.assign({}, i)
          this.newStepItem.lite = `${Number(i.lite) + 1}`
        }else{
          this.newStepItem = i
        }
        this.$store.dispatch('setkey', { key: 'StepLite', value: this.newStepItem.lite })
        this.$store.dispatch('setkey', { key: 'StepKey', value: this.newStepItem.keyName })
      }else{
        this.$store.dispatch('setkey', { key: 'StepLite', value: i.lite })
        this.$store.dispatch('setkey', { key: 'StepKey', value: i.keyName })
      }
      setTimeout(e => {
        if (this.$common.AccAUTH(this.$store.state.cause.accuser.id, this.$store.state.editJA ? 'cause:step:ja:add' : this.$store.getters.stepPower.add)) {
          if(index == '7'){
            this.$emit("lite", this.newStepItem.element)
          }else{
            this.$emit("lite", i.element)
          }
          this.close();
        }
        else {
          this.$message.error('暂无权限')
        }
      }, 100)

    }
  }
}
</script>
<style lang="less" scoped>
.stepmodel{
  display:flex;justify-content: center;
}
.modal{
  position: relative;
}
.setnewstepbtn{
  position: absolute;
  right: 40px;
  top: 16px;
}
.dl {
  // margin-bottom: 10px;

  .levelone{
    font-size: 1rem;
    color: #1d8bfe;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .dt {
    font-size: 0.875rem;
    color: #0e2949;
    line-height: 18px;
    font-weight: 500;
    margin-bottom: 8px;
    margin-left: 10px;
  }

  .dd {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-left: 10px;

    .a {
      width: 136px;
      line-height: 36px;
      background: #e0eaf7;
      border-radius: 4px;
      text-align: center;
      color: #0000004b;
      margin-right: 15px;
      margin-bottom: 10px;
      font-size: 13px;
      cursor: pointer;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
        color: #fff;
      }
    }

    .over {
      background: rgba(14, 41, 73, 0.1);
      color: #fff;

      &:hover {
        background: rgba(14, 41, 73, 0.1);
      }
    }
    .gray-disabled {
      background-color: #f5f5f5 !important; /* 浅灰背景 */
      color: #999 !important; /* 灰色文字 */
      cursor: not-allowed !important; /* 禁用鼠标指针 */
      pointer-events: none; /* 禁止点击事件（可选，根据需求是否禁用点击） */
    }
  }
}
</style>